import React from 'react';
import { Link } from 'react-router-dom';

const Refund = () => (
  <div className="min-h-screen bg-[#0e0e0e] text-white px-4 py-8">
    <div className="max-w-2xl mx-auto">
      <Link to="/login" className="text-red-500 hover:text-red-400 text-sm mb-6 inline-block">← Back to Login</Link>
      <h1 className="text-2xl font-bold text-red-500 mb-6">Refund Policy</h1>
      <div className="text-white/80 space-y-4 leading-relaxed text-sm">
        <p>Last updated: {new Date().toLocaleDateString()}</p>
        <h2 className="text-lg font-semibold text-white mt-6">Tip Payments and Refunds</h2>
        <p>Tips are voluntary and generally non-refundable once processed and transferred for artist payout.</p>
        <p>Before payout processing, pending tips may be cancelled upon valid request. HubTune may temporarily hold funds for security, fraud prevention, and payout processing.</p>
        <p>In cases of unauthorized transactions or chargebacks, HubTune reserves the right to investigate, reverse, or hold related balances in accordance with applicable law and our internal policies.</p>
        <h2 className="text-lg font-semibold text-white mt-6">Contact</h2>
        <p>
          You can contact HubTune at:
        </p>
        <p className="space-y-1">
          <span className="block"><span className="font-semibold">Name:</span> Ayush Kumar</span>
          <span className="block"><span className="font-semibold">Office Address:</span> 4351, Gali Number 8, Ajit Nagar, Gandhi Nagar, East Delhi, Delhi – 110031, India</span>
          <span className="block">
            <span className="font-semibold">Email:</span>{" "}
            <a
              href="mailto:ayushk76596@gmail.com"
              className="text-red-400 hover:text-red-300 underline"
            >
              ayushk76596@gmail.com
            </a>
          </span>
          <span className="block">
            <span className="font-semibold">Phone:</span>{" "}
            <a
              href="tel:+917080176462"
              className="text-red-400 hover:text-red-300 underline"
            >
              +91 7080176462
            </a>
          </span>
        </p>
      </div>
    </div>
  </div>
);

export default Refund;
